import { styled } from '@mui/material';
import classNames from 'classnames';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { ConversationMessageView } from '../ConversationMessageView';
import { IConversationMessageContentProps } from './types';

const Content = styled(ConversationMessageView)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  wordBreak: 'break-word',
  maxWidth: '100%',
  '&.compact': {
    color: theme.palette.text.secondary,
  },
  '&.isImage': {
    marginTop: theme.spacing(1),
    '&.isReply': {
      marginTop: theme.spacing(0.5),
    },
  },
}));

export function ConversationMessageContentText({
  message,
  compact,
  className,
  editor,
  isReply,
}: IConversationMessageContentProps) {
  return (
    <Content
      content={message.content as string}
      editor={editor}
      disabled
      plaintext={compact}
      className={classNames(className, {
        compact,
        isReply,
        isImage: message.contentType !== ConversationMessageContentType.TEXT,
      })}
      edited={message.edited}
    />
  );
}
